import Box from "@mui/material/Box";
import type { ComponentChildren, JSX } from "preact";

import { BaseModal } from "./BaseModal";
import styles from "./Modal.module.css";
import { TextButton } from "./TextButton";

type SelectionOption = {
  text: string;
  onClicked: () => void;
};

type ModalProps = {
  shown: boolean;
  titleText?: string;
  descriptionText?: string | JSX.Element[];
  onYes?: SelectionOption;
  onBtns?: SelectionOption[];
  onNo?: SelectionOption;
  children?: ComponentChildren;
};

export const Modal = (props: ModalProps) => {
  return (
    <BaseModal aria-labelledby="modal-title" aria-describedby="modal-description" open={props.shown}>
      <Box className={`${styles.modalBox} supportsRtl`}>
        {props.titleText ? (
          <div id="modal-title" className={styles.modalTitle}>
            {props.titleText}
          </div>
        ) : null}
        {props.descriptionText ? (
          <div id="modal-description" className={styles.modalDescription}>
            {props.descriptionText}
          </div>
        ) : null}
        {props.children}
        <div className={styles.modalButtonContainer}>
          {props.onYes ? (
            <TextButton
              className={styles.modalYesButton}
              onClick={props.onYes.onClicked}
              variant="contained"
              component={"button"}
            >
              {props.onYes.text}
            </TextButton>
          ) : null}
          {props.onBtns && props.onBtns.length > 0
            ? props.onBtns.map((option, index) => {
                return (
                  <TextButton
                    key={index}
                    className={styles.modalYesButton}
                    onClick={option.onClicked}
                    variant="contained"
                  >
                    {option.text}
                  </TextButton>
                );
              })
            : null}
          {props.onNo ? (
            <TextButton
              className={styles.modalNoButton}
              onClick={props.onNo.onClicked}
              variant="contained"
              component={"button"}
            >
              {props.onNo.text}
            </TextButton>
          ) : null}
        </div>
      </Box>
    </BaseModal>
  );
};
